export default __webpack_public_path__ + "static/media/pin-patrol.0d8f64db.svg";